export  enum CatalogType {
    General = 'general',
    Media = 'media'
}
